import { render, staticRenderFns } from "./moreList.vue?vue&type=template&id=588e5a39&scoped=true&"
import script from "./moreList.vue?vue&type=script&lang=js&"
export * from "./moreList.vue?vue&type=script&lang=js&"
import style0 from "./moreList.vue?vue&type=style&index=0&id=588e5a39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588e5a39",
  null
  
)

export default component.exports